const PointsMultiplierMetertest = {}

const PointsMultiplierArb = {
  ['0x59aC82d3EfB5dc6c4389ccfF7AB7ab6C72C6AC05'.toLowerCase()]: ['2x Sumer Points'],
  ['0x32be989F762470473878456aB3fB8f6a5bb0205c'.toLowerCase()]: [
    // solv btc
    '1.5x Sumer Points',
    '3X Solv Points',
  ],
  ['0x1a9CFA6c676ebBEd450dB3cef03e399465F1202C'.toLowerCase()]: ['2x Sumer Points'],
  ['0x1167e762541374fEBeeA0f6Ed2AD4473AFa1CcEa'.toLowerCase()]: ['2x Sumer Points'],
  ['0x3C752d0D78BbFddA6BF4b6000a01228B732441aE'.toLowerCase()]: ['3x Sumer Points'],
  ['0xd5BDa72030d9531fb311ddFE09aF5502C3492E0c'.toLowerCase()]: [
    // weETH
    '1.5x Sumer Points',
    '2x EtherFi Points',
    '1x EigenLayer Points',
  ],
  ['0x873449359d2d99691436E724C6C219a39b159B4a'.toLowerCase()]: ['3x Sumer Points'],
  ['0x4DE3741E1676ed14d661b1398196dC221cA4D37A'.toLowerCase()]: ['3x Sumer Points'],
  ['0xDb7Fe9c415281E383595c262e49568DDc18e8Bd4'.toLowerCase()]: ['3x Sumer Points'],
  ['0x142017b52c99d3dFe55E49d79Df0bAF7F4478c0c'.toLowerCase()]: ['1.5x Sumer Points'],
  ['0x6C6E01110563305537d303e468B23A453BED2197'.toLowerCase()]: [
    // PT-weETH-26DEC2024
    '1x Sumer Points',
  ],
  ['0x54525258ba4f089e72f062b0cc66774639B2e259'.toLowerCase()]: [
    // PT-rsETH-26DEC2024
    '1x Sumer Points',
  ],
  ['0xEe67DB245248BDC84a6634e9A3e30FF78Eeb6179'.toLowerCase()]: [
    // rsETH
    '1.5x Sumer Points',
    '1x Kelp Miles',
    '1x EigenLayer Points',
  ],
}

const PointsMultiplierBase = {
  ['0x6345aF6dA3EBd9DF468e37B473128Fd3079C4a4b'.toLowerCase()]: ['1.5x Sumer Points'], // cbeth
  ['0x238d804Cb1F4c0c7495e7b7773c54D75E4C99cdd'.toLowerCase()]: ['2x Sumer Points'], // wsteth
  ['0x2AA93D3142d7327307b770Dba2e87C97b86B95Bc'.toLowerCase()]: ['3x Sumer Points'], // eth
  ['0xb330cae9C6207dF60C2785b29F775DEC0FE20026'.toLowerCase()]: ['1x Sumer Points'],
  ['0xA4578AB5CDA88AaE7603aFAB24b4c0d24a7858D1'.toLowerCase()]: ['3x Sumer Points'], // dai
  ['0x3389eD4dd777b03B95deb2994ACaF6807cf24c2E'.toLowerCase()]: ['3x Sumer Points'], // usdbc
  ['0x142017b52c99d3dFe55E49d79Df0bAF7F4478c0c'.toLowerCase()]: ['3x Sumer Points'], // usdc
  ['0x0BAd894e6c094Ee78924982b09eE54B6e24Af7F1'.toLowerCase()]: ['2x Sumer Points'], // cb btc
  ['0x6f06a771104F22B006037313954Ef289a1f26Ddd'.toLowerCase()]: ['3x Sumer Points'], // eurc
  ['0x7b1D6dda0cB59c0c87a3d07e97a66e23aE3aF969'.toLowerCase()]: ['1.5x Sumer Points'], // stUSD
  ['0xdf1d98A8A1439D348949c72Abf3f678e8B0BF87b'.toLowerCase()]: ['1.5x Sumer Points'], // stEUR
}

const PointsMultiplierETH = {
  ['0x42778d0962884510b85d4D1B30DFe9e9Dd270446'.toLowerCase()]: [
    // eth
    '2x Sumer Points',
  ],
  ['0xdCA98947c3c9cf0B3CF448b6A03f991598Fb9460'.toLowerCase()]: [
    // wbtc
    '1.5x Sumer Points',
  ],
  ['0x1FF86e97b273dE2b1D42F0FDD5Ea7350A66c4857'.toLowerCase()]: [
    // reth
    '1.5x Sumer Points',
  ],
  ['0x15B5220024c3242F7D61177D6ff715cfac4909eD'.toLowerCase()]: [
    // wsteth
    '1.5x Sumer Points',
  ],
  ['0x23811C17BAc40500deCD5FB92d4FEb972aE1E607'.toLowerCase()]: [
    // pufeth
    '1x Sumer Points',
    '1x Puffer Points',
    '1x EigenLayer Points',
  ],
  ['0x61561B2E01C69C2906735866C94Cc4a33bB71c85'.toLowerCase()]: [
    // rseth
    '1x Sumer Points',
    '1x Kelp Miles',
    '1x EigenLayer Points',
  ],
  ['0xBc6590A7b15513e4D649b158393175a839F27ED8'.toLowerCase()]: [
    // weeth
    '1x Sumer Points',
    '2x EtherFi Points',
    '1x EigenLayer Points',
  ],
  ['0x5096E5cf4f151052ACD615b2635E7FdB6Db0763C'.toLowerCase()]: [
    // dai
    '1x Sumer Points',
  ],
  ['0xe3502f1c2450Ed1Bb87B87a84AF6742F60f41368'.toLowerCase()]: [
    // usdt
    '2x Sumer Points',
  ],
  ['0x3d592e26050e132Ee3D1504aca74f0F4Ed75e5cC'.toLowerCase()]: [
    // usdc
    '2x Sumer Points',
  ],
  ['0xF5d682D42e16550Cc5D8f48193243103D2CeAF0a'.toLowerCase()]: [
    // usde
    '1x Sumer Points',
  ],
  ['0x549D0CdC753601fbE29f9DE186868429a8558E07'.toLowerCase()]: [
    // susde
    '1x Sumer Points',
  ],
  ['0x3d9b5399059d36644B8b67860439Af221C67B273'.toLowerCase()]: [
    // pt weeth 26DEC2024
    '1x Sumer Points',
  ],
  ['0x09Ec28782a71627b61Dce160Fc0FBbC1edBd2A6D'.toLowerCase()]: [
    // pt rsETH 26DEC2024
    '1x Sumer Points',
  ],
  ['0x29688DdC25ecd3307Aa4A83CA3AbB18F6AD70738'.toLowerCase()]: [
    // pt pufeth 26DEC2024
    '1x Sumer Points',
  ],
  ['0xA9Ea90899fA648b4Ce49f6aE28174AEAda660118'.toLowerCase()]: [
    // solv btc
    '1.5x Sumer Points',
    '3X Solv Points',
  ],
  ['0x5573Fc3650d2a38D1C83faDf682bC379CFAcCFA1'.toLowerCase()]: [
    // solv btc bbn
    '1.5x Sumer Points',
    '3X Solv Points',
    'Babylon Rewards',
  ],
  ['0x91942b802439f2169C36441eF3b250AF6bAc15bD'.toLowerCase()]: [
    // fbtc
    '1x Sumer Points',
  ],
  ['0x1bC39d2E227481087f21de67Bae32BC5bc36C70b'.toLowerCase()]: [
    // tbtc
    '1x Sumer Points',
  ],
  ['0x83db38Aa8d165340012bb734bdd408C46a39d6dD'.toLowerCase()]: [
    // ebtc
    '1x Sumer Points',
    'Babylon Rewards',
  ],
}

const PointsMultiplierMeter = {
  ['0x52e245606Dd37A9addcD2Bb523d319596eB4b851'.toLowerCase()]: [
    // eth
    '3x Sumer Points',
    '1x Meter Points',
  ],
  ['0x6Ff2fB3F8F175df0A39C344de81A4aaaB05c49eB'.toLowerCase()]: [
    // mtrg
    '2x Sumer Points',
    '1x Meter Points',
  ],
  ['0x318F6863a8c516dF9C5941AEb328A40f15f525F9'.toLowerCase()]: [
    // wstmtrg
    '2x Sumer Points',
    '1x Meter Points',
  ],
  ['0xC211a250FC30122ee107aC9Acf6686110339520f'.toLowerCase()]: [
    // usdc
    '3x Sumer Points',
    '1x Meter Points',
  ],
  ['0xaCEDC263FF6De824B38cAeAAC1FD877b1a7344a1'.toLowerCase()]: [
    // usdt
    '3x Sumer Points',
    '1x Meter Points',
  ],
}

const PointsMultiplierZklink = {
  ['0x54Dfae480e33dC2BEfd42CAA26A432b11b5a27Bd'.toLowerCase()]: [
    // eth
    '3x Sumer Points',
    '20x zkLink Points',
  ],
  ['0x22203549A2Fe6740A3D85f8ed2cdfDE16464B68B'.toLowerCase()]: [
    // usdc
    '3x Sumer Points',
    '20x zkLink Points',
  ],
  ['0x45f832bd90b50A97f494A5578ea038CaD03C2b3b'.toLowerCase()]: [
    // usdt
    '3x Sumer Points',
    '20x zkLink Points',
  ],
  ['0x450665dA7c7b72302Ac6fB6b1B20de7bCF38F7c1'.toLowerCase()]: [
    // wbtc
    '2x Sumer Points',
    '20x zkLink Points',
  ],
  ['0x2440414bc0Bf6f7E76CB2f2C5051EdC4a940d441'.toLowerCase()]: [
    // mbtc
    '1.5x Sumer Points',
    '4x zkLink Points',
  ],
  ['0x22c3E783AC857E205523b59EFC4739949f93EE81'.toLowerCase()]: [
    // solv btc
    '1.5x Sumer Points',
    '4x zkLink Points',
  ],
  ['0xE143694271a0b34ea6C7928d9B66d31f60B2BfeD'.toLowerCase()]: [
    // puf eth
    '1.5x Sumer Points',
    '4x zkLink Points',
    '1x Puffer Points',
    '1x EigenLayer Points',
  ],
  ['0x03979c0Fba55EA5A8022c79951fEED1c4a3C8324'.toLowerCase()]: [
    // stone
    '1x Sumer Points',
    '4x zkLink Points',
  ],
  ['0x67CF127b95A6B957aeDEA5B15626311245167979'.toLowerCase()]: [
    // manta
    '1x Sumer Points',
    '4x zkLink Points',
  ],
}

const PointsMultiplierBSC = {
  ['0xBc6590A7b15513e4D649b158393175a839F27ED8'.toLowerCase()]: [
    // usdc
    '3x Sumer Points',
  ],
  ['0xE550a6f792a8B6C07555378EA74063021885A33e'.toLowerCase()]: [
    // usdt
    '3x Sumer Points',
  ],
  ['0xf7BB299dc8e627eaEc4282FFc236E085aef8FAF3'.toLowerCase()]: [
    // btcb
    '2x Sumer Points',
  ],
  ['0x86208Af42580823401B504B341150c92CC99C69A'.toLowerCase()]: [
    // solv btc
    '1.5x Sumer Points',
    '3X Solv Points'
  ],
  ['0xdCA98947c3c9cf0B3CF448b6A03f991598Fb9460'.toLowerCase()]: [
    // solv btc.bbn
    '1.5x Sumer Points',
    '3X Solv Points'
  ],
  ['0x218C9349E8522466bD57FB878a1a479AeAEF02a4'.toLowerCase()]: [
    // solv btc.ena
    '1.5x Sumer Points',
    '3X Solv Points'
  ],
  ['0x35C840655D3a2E77d79f179C34e547726B963314'.toLowerCase()]: [
    // pump btc
    '1x Sumer Points',
  ],
  ['0x2509bd3B69440D39238b464d09f9F04A61fd62C6'.toLowerCase()]: [
    // eth
    '3x Sumer Points',
  ],
  ['0x23811C17BAc40500deCD5FB92d4FEb972aE1E607'.toLowerCase()]: [
    // bnb
    '3x Sumer Points',
  ],
}

const PointsMultiplierB2 = {
  ['0x163cEbBD83A4e2821fF06C9b0707A8A64FEc0AbC'.toLowerCase()]: [
    // usdc
    '3x Sumer Points',
  ],
  ['0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488'.toLowerCase()]: [
    // usdt
    '3x Sumer Points',
  ],
  ['0xAbcdc5827f92525F56004540459045Ec3e432ebF'.toLowerCase()]: [
    // wbtc
    '2x Sumer Points',
  ],
  ['0x7465fedB29023d11effe8C74E82A7ecEBf15E947'.toLowerCase()]: [
    // ubtc
    '2x Sumer Points',
  ],
}

const PointsMultiplierMerlin = {
  ['0x8C38b023Afe895296e2598AE111752223185b35c'.toLowerCase()]: [
    // usdc
    '3x Sumer Points',
  ],
  ['0xb1FdC3f660b0953253141B2509c43014d5d3d733'.toLowerCase()]: [
    // usdt
    '3x Sumer Points',
  ],
  ['0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc'.toLowerCase()]: [
    // mbtc
    '1.5x Sumer Points',
  ],
  ['0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276'.toLowerCase()]: [
    // solvbtc
    '1.5x Sumer Points',
  ],
}

const PointsMultiplierCore = {
  
  ['0xb1FdC3f660b0953253141B2509c43014d5d3d733'.toLowerCase()]: [
    // usdc
    '4x Sumer Points',
    '3x Core Ignition'
  ],
  ['0xc7fFEAa5949d50A408bD92DdB0D1EAcef3F8a3Bc'.toLowerCase()]: [
    // usdt
    '4x Sumer Points',
    '3x Core Ignition'
  ],
  ['0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276'.toLowerCase()]: [
    // solvbtc.b
    '1x Sumer Points',
    '3x Core Ignition'
  ],
  ['0xf902e1925B50ac70285b73FD065af971487c2E4d'.toLowerCase()]: [
    // solvbtc.m
    '1.5x Sumer Points',
    '3x Core Ignition'
  ],
  ['0xdb4d020A58e0A1A67823d75437A61044dC02AE4C'.toLowerCase()]: [
    // solvbtc.core
    '1x Sumer Points',
    '3x Core Ignition'
  ],
  ['0x9aa55bCf3E41D0d98FCe816C4eC6E791B0f6d154'.toLowerCase()]: [
    // core
    '2x Sumer Points',
    '3x Core Ignition'
  ],
  ['0x58235d9C8c9f136c0A4e9761186dB0329243bbB8'.toLowerCase()]: [
    // stcore
    '2x Sumer Points',
    '3x Core Ignition'
  ],
  ['0xddab3eb6028a44Fb31F9Da92eA1608809248B6b3'.toLowerCase()]: [
    // btcb
    '2x Sumer Points',
    '3x Core Ignition'
  ],
  ['0x45f7a835c5b490288ABE36CF3d25a1119135d60F'.toLowerCase()]: [
    // dualCORE
    '2x Sumer Points',
  ],
  ['0x8B2da7D9242E631C6f3E1d40Db3407b2F15FFa84'.toLowerCase()]: [
    // wbtc
    '4x Sumer Points',
  ]
}

const PointsMultiplierBera = {
  ['0x6116438fD4abDd902dcA8e0335144F700B1a5147'.toLowerCase()]: [
    // BERA
    '4x Sumer Points',
  ],
  ['0xb1FdC3f660b0953253141B2509c43014d5d3d733'.toLowerCase()]: [
    // ETH
    '4x Sumer Points',
  ],
  ['0x10A2e256Bed7b3c49C151Ad1Bad01F4936FC9276'.toLowerCase()]: [
    // NECT
    '4x Sumer Points',
  ],
  ['0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E'.toLowerCase()]: [
    // HONEY
    '4x Sumer Points',
  ],
  ['0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52'.toLowerCase()]: [
    // USDC
    '4x Sumer Points',
  ],
  ['0xf70B2473e7808eDAeA4A5Cea95996A9B1843D96C'.toLowerCase()]: [
    // WBTC
    '4x Sumer Points',
  ],
  ['0x2CB37855fb2Dc0b4C204E242b6A5f731c22AD4bc'.toLowerCase()]: [
    // STONE
    '1.5x Sumer Points'
  ],
  ['0x341fDb6532154Cec491Aca3D3BB404C2d4cc042E'.toLowerCase()]: [
    // USDC_HONEY_BEX
    '1x Sumer Points'
  ],
  ['0x45f7a835c5b490288ABE36CF3d25a1119135d60F'.toLowerCase()]: [
    // BYUSD_HONEY_BEX
    '1x Sumer Points'
  ],
  ['0xE9b2f0c9c4868Db97623876191D268b53d9523f7'.toLowerCase()]: [
    // iBera_wBERA_BEX
    '1x Sumer Points'
  ]
}

const PointsMultiplierHemi = {
  ['0x8c1ad24cA39FE45E97CD9862364128406E3B03F3'.toLowerCase()]: [
    // ETH  4(first two week) -> 4
    '4x Sumer Points',
  ],
  ['0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488'.toLowerCase()]: [
    // USDC 4 -> 4
    '4x Sumer Points',
  ],
  ['0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E'.toLowerCase()]: [
    // USDT 4 -> 4
    '4x Sumer Points',
  ],
  ['0x7465fedB29023d11effe8C74E82A7ecEBf15E947'.toLowerCase()]: [
    // rsETH  2 -> 1.5
    '1.5x Sumer Points',
  ],
  ['0x58235d9C8c9f136c0A4e9761186dB0329243bbB8'.toLowerCase()]: [
    // wbtc 4
    '4x Sumer Points'
  ],
  ['0xdb4d020A58e0A1A67823d75437A61044dC02AE4C'.toLowerCase()]: [
    // hemi btc
    '1.5 Sumer Points'
  ]
}

const PointsMultiplierGoat = {
  ['0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E'.toLowerCase()]: [
    // esBTC
    '1x Sumer Points',
  ],
  ['0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E'.toLowerCase()]: [
    // nETH
    '1x Sumer Points'
  ],
  ['0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488'.toLowerCase()]: [
    // uBTC
    '1x Sumer Points'
  ]
}

export const PointsMultiplier = {
  83: PointsMultiplierMetertest,
  42161: PointsMultiplierArb,
  8453: PointsMultiplierBase,
  1: PointsMultiplierETH,
  82: PointsMultiplierMeter,
  810180: PointsMultiplierZklink,
  56: PointsMultiplierBSC,
  223: PointsMultiplierB2,
  4200: PointsMultiplierMerlin,
  1116: PointsMultiplierCore,
  80094: PointsMultiplierBera,
  43111: PointsMultiplierHemi,
  2345: PointsMultiplierGoat,
}
